import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import useReportMealDaily from 'hooks/communication/useReportMealDaily';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';
import React from 'react';
import { numberWithComma } from 'utils/number';
import * as Luxon from 'luxon'
import { luxonClone } from 'utils/time';
import CpfRatioBox from './CpfRatioBox';
import usePaging from 'hooks/tables/usePaging';
import PagingIndicator from 'components/common/paging/PagingIndicator';
import defaultRenderPrevButtons from 'components/common/paging/defaultRenderPrevButtons';
import defaultRenderNextButtons from 'components/common/paging/defaultRenderNextButtons';
import WEEK_DAY_COLUMNS from 'constants/WEEK_DAY_COLUMNS';
import ExerciseDialog from 'components/dialogs/ExerciseDialog';
import DialogButton from 'components/common/DialogButton';
import useSetChartData from 'hooks/app/useSetChartData';

const PAGE_ROW_CNT = 5;
export default function DietStatisticsTable(props) {
  const {
    page,
    onPage,
    npage,
    onNPage,
    maxPage,
    onMaxPage
  } = usePaging({
    resetCondition: [],
    defaultMaxPage: 6,
  });

  const {
    requestReportMealDaily,
  } = useReportMealDaily();

  const setChartData = useSetChartData('DietDailyStatistics');
  const [data, setData] = React.useState({});
  // const [list, setList] = React.useState([]);
  const period_start = Recoil.useRecoilValue(AppStore.assets.period_start);
  const period_end = Recoil.useRecoilValue(AppStore.assets.period_end);
  const patient_no = Recoil.useRecoilValue(AppStore.assets.patient_no);
  React.useEffect(() => {
    requestReportMealDaily({
      patient_no,
      search_start_time: period_start,
      search_end_time: period_end,
      page_row_cnt: PAGE_ROW_CNT,
      page_no: npage,
    }, (success, data) => {
      if (success) {
        setChartData(() => data);
        setData(() => data || {});
        onMaxPage(data.max_page_no || 1);
        onPage(data.page_no || 1);
      } else {
        setData(() => ({}));
        onMaxPage(1);
        onPage(1);
        onNPage(1);
      }
    });
  }, [npage, onMaxPage, onNPage, onPage, patient_no, period_end, period_start, requestReportMealDaily, setChartData]);

  const {
    meal_stat_list: list = [],
  } = data || {};

  return (
    <div {...ex('DietStatisticsTable', props)}>
      <table>
        <thead>
          <tr>
            <th>
              <div>
                {T('날짜')}
              </div>
            </th>
            <th>
              <div>
                {T('기록(회)')}
              </div>
            </th>
            <th>
              <div>
                {T('섭취칼로리(kcal)')}
              </div>
            </th>
            <th>
              <div>
                {T('탄수화물(g)')}
              </div>
            </th>
            <th>
              <div>
                {T('단백질(g)')}
              </div>
            </th>
            <th>
              <div>
                {T('지방(g)')}
              </div>
            </th>
            <th>
              <div>
                {T('탄단지 비율(%)')}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div>
                {T('전체 (일평균)')}
              </div>
            </td>
            <td>
              <div>
                {data.tot_total_intaken_cnt}
              </div>
            </td>
            <td>
              <div>
                {numberWithComma(data.tot_avg_cal)}
              </div>
            </td>
            <td>
              <div>
                {numberWithComma(data.tot_avg_carbo_cal)}
              </div>
            </td>
            <td>
              <div>
                {numberWithComma(data.tot_avg_protein_cal)}
              </div>
            </td>
            <td>
              <div>
                {numberWithComma(data.tot_avg_fat_cal)}
              </div>
            </td>
            <td>
              <div>
                {T('{0}-{1}-{2}', data.tot_avg_carbo_rate, data.tot_avg_protein_rate, data.tot_avg_fat_rate)}
              </div>
            </td>
          </tr>
          {list.map((item, index) => {
            const {
              time,

              day_intaken_cal,
              day_intaken_carbo_amt,
              day_intaken_protein_amt,
              day_intaken_fat_amt,

              avg_cal,
              avg_carbo_cal,
              avg_carbo_rate,
              avg_fat_cal,
              avg_fat_rate,
              avg_protein_cal,
              avg_protein_rate,
              day_tp_cd,
              total_intaken_cnt,
            } = item;
            const luxon = Luxon.DateTime.fromFormat(time, 'yyyyMMdd');
            const date = luxon.toFormat("yy.MM.dd");
            const weekday = luxonClone(luxon).weekday;
            return (
              <tr key={index}>
                <td>
                  <div>
                    <DialogButton
                      {...{ category: 'App' }}
                      {...ex('ExerciseDialogButton')}
                      {...{ label: T('{0}({1})', date, WEEK_DAY_COLUMNS[weekday - 1]) }}
                    >
                      <ExerciseDialog
                        {...{
                          luxon,
                        }}
                      />
                    </DialogButton>
                  </div>
                </td>
                <td>
                  <div>
                    {total_intaken_cnt}
                  </div>
                </td>
                <td>
                  <div>
                    {numberWithComma(day_intaken_cal)}
                  </div>
                </td>
                <td>
                  <div>
                    {numberWithComma(day_intaken_carbo_amt)}
                  </div>
                </td>
                <td>
                  <div>
                    {numberWithComma(day_intaken_protein_amt)}
                  </div>
                </td>
                <td>
                  <div>
                    {numberWithComma(day_intaken_fat_amt)}
                  </div>
                </td>
                <td>
                  <div>
                    {T('{0}-{1}-{2}', avg_carbo_rate, avg_protein_rate, avg_fat_rate)}
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
      <PagingIndicator
        {...{
          indicatorCount: 5,
          maxPage,
          page,
          onNPage,
          renderPrevButtons: defaultRenderPrevButtons,
          renderNextButtons: defaultRenderNextButtons,
        }}
      />
    </div>
  );
}
